import {
  Divider,
  DownloadIcon,
  DragDrop,
  ExcelIcon,
  GKButton,
  Grid2,
  Typography,
} from "components";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useDownloadSampleFileMutation } from "store/features/MyWebsite";
import { exportArrayBufferToExcel } from "utils/exportCsv";
import { WebsiteDetails } from "./types";

const ComplainResolutionForm = () => {
  const form = useFormContext<WebsiteDetails>();

  const [uploadError, setUploadError] = useState<any>();

  const [downloadSampleFile, { isLoading }] = useDownloadSampleFileMutation();

  const DownloadBtn = ({ type }: { type: string }) => {
    return (
      <GKButton
        variant="outlined"
        color="dark"
        target="_blank"
        loading={isLoading}
        startIcon={<DownloadIcon />}
        endIcon={<ExcelIcon />}
        onClick={async () => {
          try {
            const response = await downloadSampleFile({ type }).unwrap();
            exportArrayBufferToExcel(response, type);
          } catch (error) {
            console.error("Error downloading sample file:", error);
          }
        }}
      >
        Download Template
      </GKButton>
    );
  };

  return (
    <Grid2 container spacing={3} p={2}>
      <Grid2 size={12}>
        <Typography fontSize={14} fontWeight={700} color="var(neutral-900)">
          Complaints Resolution
        </Typography>
      </Grid2>

      <Grid2 container size={8} spacing={1}>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={600} color={"var(--grey-900)"}>
            Current Month
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Controller
            name={"compliance.complaintResolution.monthWise"}
            control={form.control}
            render={({ field, fieldState: { error } }) => (
              <DragDrop
                {...field}
                uploadError={uploadError}
                setUploadError={setUploadError}
                onChange={(e) => field.onChange(e)}
                supportName="CSV & XLSX"
                acceptType={".csv,.xlsx"}
                error={!!error}
              />
            )}
          />
        </Grid2>
        <Grid2 size={12}>
          <DownloadBtn type="month-wise" />
        </Grid2>
      </Grid2>

      <Grid2 size={12}>
        <Divider />
      </Grid2>

      <Grid2 container size={8} spacing={1}>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={600} color={"var(--grey-900)"}>
            Monthly
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Controller
            name={"compliance.complaintResolution.monthly"}
            control={form.control}
            render={({ field, fieldState: { error } }) => (
              <DragDrop
                {...field}
                uploadError={uploadError}
                setUploadError={setUploadError}
                onChange={(e) => field.onChange(e)}
                supportName="CSV & XLSX"
                acceptType={".csv,.xlsx"}
                error={!!error}
              />
            )}
          />
        </Grid2>
        <Grid2 size={12}>
          <DownloadBtn type="monthly" />
        </Grid2>
      </Grid2>

      <Grid2 size={12}>
        <Divider />
      </Grid2>

      <Grid2 container size={8} spacing={1}>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={600} color={"var(--grey-900)"}>
            Annually
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Controller
            name={"compliance.complaintResolution.annual"}
            control={form.control}
            render={({ field, fieldState: { error } }) => (
              <DragDrop
                {...field}
                uploadError={uploadError}
                setUploadError={setUploadError}
                onChange={(e) => field.onChange(e)}
                supportName="CSV & XLSX"
                acceptType={".csv,.xlsx"}
                error={!!error}
              />
            )}
          />
        </Grid2>
        <Grid2 size={12}>
          <DownloadBtn type="yearly" />
        </Grid2>
      </Grid2>

      {/* <Grid2 size={12} mt={2} display={"flex"} justifyContent={"flex-end"}>
        <GKButton
          variant="contained"
          loading={isLoading}
          onClick={form.handleSubmit((values: any) => {
            const formData = new FormData();

            if (values.monthly.length === 1) {
              formData.append("monthly", values.monthly[0]);
            }
            if (values.monthWise.length === 1) {
              formData.append("monthWise", values.monthWise[0]);
            }
            if (values.annual.length === 1) {
              formData.append("annual", values.annual[0]);
            }

            uploadComplains(formData);
          })}
        >
          Save
        </GKButton>
      </Grid2> */}
    </Grid2>
  );
};

export default ComplainResolutionForm;
